<template>
  <BContainer
    fluid
  />
</template>
<script>
export default {
  name: 'VAdminDashboard',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  }
}
</script>
